if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeHelloCards);
} else {
  initializeHelloCards()
}

function initializeHelloCards () {
  const helloCards = document.getElementsByClassName('hello-card');
  Array.from(helloCards).forEach((helloCard) => {
    initializeCard(helloCard)
  })
}

function initializeCard (cardElement) {
  const contentElement = cardElement.querySelector('.hello-card__content')
  const headingElement = cardElement.querySelector('.hello-card__heading')
  const descriptionElement = cardElement.querySelector('.hello-card__description')
  const captionElement = cardElement.querySelector('.hello-card__caption')

  initializeTextContent(headingElement)
  initializeTextContent(descriptionElement)
  initializeTextContent(captionElement)

  let firstOrder = Number(getComputedStyle(contentElement.firstElementChild).order)
  let lastOrder = Number(getComputedStyle(contentElement.firstElementChild).order)
  let firstElement = contentElement.firstElementChild
  let lastElement = contentElement.firstElementChild
  Array.from(contentElement.children).forEach((el) => {
    const currentOrder = Number(getComputedStyle(el).order)
    if (currentOrder < firstOrder) {
      firstOrder = currentOrder
      firstElement = el
    }
    if (currentOrder > lastOrder) {
      lastOrder = currentOrder
      lastElement = el
    }
  })
  firstElement.classList.add('hello-card__first')
  lastElement.classList.add('hello-card__last')
}

function initializeTextContent (element) {
  if (element && element.dataset.text) {
    let parsedText = parseHtml(element.dataset.text)
    let splittedText = parsedText.split('<p>&lt;hr&gt;</p>')
    if (splittedText.length > 1) {
      parsedText = splittedText
        .map(item => `<div>${item.trim()}</div>`)
        .join('')
    }
    element.innerHTML = parsedText
  }
}